/**
 * Created by adalto on 6/3/14.
 */

Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};
Greenmile.Task.RelatedInfo.Map = {

    createFullMapsInfo: function (data) {

        Monet.Session.Task.lastLinkForm.maps.nodes = [];
        Monet.Session.Task.lastLinkForm.maps.ids = [];
        Monet.Session.Task.lastLinkForm.maps.data = [];

        for (var i = 0, l = data.length; i < l; i++) {
            this.createMapIdNode(data[i]);
        }

    },

    createMapIdNode: function (data) {

        if (data) {
            var divContainer = document.createElement('div');
            var Destroylink = document.createElement('div');
            var input = document.createElement('input');
            var inputLatitude = document.createElement('input');
            var inputLongitude = document.createElement('input');
            var inputStatus = document.createElement('input');
            var mapDate = document.createElement('input');

            divContainer.id = "map_" + data.id;

            Destroylink.className = "table-action-destroylink map";

            input.type = 'hidden';
            input.name = 'maps[' + data.id + '].id';
            input.id = 'maps[' + data.id + '].id';
            input.className = "modelAttribute";
            input.value = data.id;

            mapDate.type = 'hidden';
            mapDate.name = 'maps[' + data.id + '].when';
            mapDate.id = 'maps[' + data.id + '].when';
            mapDate.className = "modelAttribute";
            mapDate.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

            inputLatitude.type = 'hidden';
            inputLatitude.name = 'maps[' + data.id + '].latitude';
            inputLatitude.id = 'maps[' + data.id + '].latitude';
            inputLatitude.className = "modelAttribute";
            inputLatitude.value = data.latitude;

            inputLongitude.type = 'hidden';
            inputLongitude.name = 'maps[' + data.id + '].longitude';
            inputLongitude.id = 'maps[' + data.id + '].longitude';
            inputLongitude.className = "modelAttribute";
            inputLongitude.value = data.longitude;

            inputStatus.type = 'hidden';
            inputStatus.name = 'maps[' + data.id + '].status';
            inputStatus.id = 'maps[' + data.id + '].status';
            inputStatus.className = "modelAttribute";
            inputStatus.value = '';

            Destroylink.addEventListener('click', (function (scope, data) {

                return function (e) {

                    e.preventDefault();

                    const confirmDeleteMap = () => {
                        
                        App.Views.Task.showLoadingElement(this);
                        scope.deleteLinkedMap(data.id, (function (e) {

                            return function () {

                                App.Views.Task.hideLoad();

                                scope.removeLinkedMapFromList(e.target);
                                scope.removeLinkedMapFromData(data.id, e.target, scope);

                                if (Monet.Session.Task.lastLinkForm.maps.nodes.length === 0) {

                                    var container = document.getElementById('relatedLinksMapTitle');
                                    container.parentNode.remove();

                                    Monet.Session.Task.addresSelected = undefined;

                                }

                            };
                        }(e)));

                    };

                    Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteMap);

                };

            }(this, data)));


            Destroylink.appendChild(input);
            Destroylink.appendChild(inputLatitude);
            Destroylink.appendChild(inputLongitude);
            Destroylink.appendChild(mapDate);

            divContainer.appendChild(inputStatus);
            divContainer.appendChild(Destroylink);

            Monet.Session.Task.lastLinkForm.maps.nodes.push(divContainer);
            Monet.Session.Task.lastLinkForm.maps.ids.push(input);
            Monet.Session.Task.lastLinkForm.maps.data.push(data);
        }
    },

    createMapOverlay: function () {

        var popupEl = document.querySelector('#Task .span10');
        var linkFormOverlay = document.createElement('div');
        var linkFormContent = document.createElement('div');

        linkFormOverlay.id = 'TaskManagerMapOverlay';
        linkFormContent.id = 'TaskManagerMapForm';

        popupEl.appendChild(linkFormOverlay);
        popupEl.appendChild(linkFormContent);

        this.createMapForms();

    },

    taskManagerMapFormTemplate: function () {
        return new Monet.UI.LayoutGenerator({
            "items": [
                {
                    "items": [
                        {
                            "attributes": {
                                "class": "alert alert-error"
                            },
                            "html": Monet.I18n.getResourcesByKey('task.needLocationSelected')
                        }
                    ],
                    "attributes": {
                        "class": "monetInlineAlerContainer"
                    }
                },
                {
                    "items": [
                        {
                            "attributes": {
                                "id": "taskManagerMapToolbar"
                            }
                        },
                        {
                            "attributes": {
                                "class": "taskManagerMapContainer",
                                "id": "taskManagerMapContainer"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "adjustsLayoutContainer"
                    }
                },
                {
                    "items": [
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "button",
                                "class": "i18nResource",
                                "name": "taskManagerPopupSave",
                                "id": "equipmentTaskManagerPopupSave",
                                "value": Monet.I18n.getResourcesByKey('default.button.save'),
                                "style": "float:right;"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "button",
                                "class": "i18nResource",
                                "name": "taskManagerPopupCancel",
                                "id": "equipmentTaskManagerPopupCancel",
                                "value": Monet.I18n.getResourcesByKey('default.button.cancel')
                            }
                        }
                    ],
                    "attributes": {
                        "class": "taskManagerButtonBoxMapsContainer standard-form-buttons"
                    }
                }
            ]
        }).render();
    },

    createMapForms: function () {

        var formOverlay = document.getElementById('TaskManagerMapForm');

        formOverlay.innerHTML = "";
        formOverlay.appendChild(this.taskManagerMapFormTemplate());

        var map = Greenmile.Map.Utility.createDefaultMap('taskManagerMapContainer');
        var baseLayer = Greenmile.Map.Utility.createBaseLayer();

        baseLayer.addTo(map);

        Monet.Session.Task.LinkMap = map;
        var options = {
            sourceSessionData: Monet.Session.Task
        };

        var helper = new Monet.UI.Help('MapRelatedInfoTask', Monet.I18n.getResourcesByKey('task.userinterface.gridlayout'));
        var toolbar = new Greenmile.Toolbar.Map(map, '#taskManagerMapToolbar', options, helper);

        toolbar.enable([
            toolbar.actions.searchAddressOnMap,
            toolbar.actions.street,
            toolbar.actions.zoom,
            toolbar.actions.source
        ]);

        toolbar.render();

        this.addMapsListeners();

    },

    addMapsListeners: function () {

        var cancelBtn  = document.getElementById('equipmentTaskManagerPopupCancel'),
            saveButton = document.getElementById('equipmentTaskManagerPopupSave');

        cancelBtn.addEventListener('click', (function (scope) {
            return function () {

                Monet.Session.Task.addresSelected = [];

                scope.destroyMapOverlay(scope);
            };
        }(this)));

        saveButton.addEventListener('click', (function (scope) {

            return function () {

                const mapForm = document.querySelector('#TaskManagerMapForm');

                if (!Monet.Session.Task.addresSelected || !Monet.Session.Task.addresSelected.length) {
                    mapForm.classList.add('showError');
                } else {
                    mapForm.classList.remove('showError');

                    Monet.Session.Task.lastLinkForm.maps.data.push({
                        id: Math.round(new Date() / 1000),
                        latitude: Monet.Session.Task.addresSelected[0].getAttribute("lat"),
                        longitude: Monet.Session.Task.addresSelected[0].getAttribute("lng")
                    });
    
                    scope.createFullMapsInfo(Monet.Session.Task.lastLinkForm.maps.data);
                    Greenmile.Task.RelatedInfo.updateRelatedInfoContent();
                    scope.destroyMapOverlay();
                }
                
            };
        }(this)));

    },

    destroyMapOverlay: function () {

        var overlay = document.getElementById('TaskManagerMapForm');
        var parentOverlay = overlay.parentNode;

        parentOverlay.removeChild(overlay);

    },

    deleteLinkedMap: function (linkedRouteId, callback) {

        var data = Monet.Session.Task.lastLinkForm.maps.data;
        var shouldMakeRequest = false;

        for (var i = 0, l = data.length; i < l; i++) {
            if (data[i].id === linkedRouteId && data[i].creationDate) {
                shouldMakeRequest = true;
                break;
            }
        }

        if (linkedRouteId && shouldMakeRequest) {
            var url = 'TaskMap/BatchDelete';

            var request = new Monet.Ajax();
            request.url = url;
            request.data = '[' + linkedRouteId + ']';
            request.method = 'post';

            request.success = function (data) {
                if (data === true) {
                    callback();
                }
            };

            request.send();
        } else {
            callback();
        }

    },

    removeLinkedMapFromList: function (el) {

        var lineItem = el.parentNode.parentNode;
        var lineItemContainer = lineItem.parentNode;

        lineItemContainer.removeChild(lineItem);
    },

    removeLinkedMapFromData: function (id) {

        var nodes = Monet.Session.Task.lastLinkForm.maps.nodes;
        var data = Monet.Session.Task.lastLinkForm.maps.data;
        var ids = Monet.Session.Task.lastLinkForm.maps.ids;
        var news = Monet.Session.Task.newTask.maps;
        var index = null;
        var newsIndex = null;

        for (var i = 0, l = nodes.length; i < l; i++) {

            var nodeId = nodes[i].id.replace('map_', ''),
                mapId  = parseInt(nodeId);

            if (mapId === id) {
                index = i;
            }
        }

        for (var j = 0, max = news.length; j < max; j++) {

            if (news[j].id === id) {
                newsIndex = j;
            }

        }

        if (index !== null) {

            nodes.splice(index, 1);
            data.splice(index, 1);
            ids.splice(index, 1);
            news.splice(newsIndex, 1);

        }
    },

    addMapRelatedInfo: function (data) {

        var selector = 'formLinkMaps_' + data.id;

        const mapData = document.querySelector('#map_' + data.id + ' .table-action-destroylink.map');

        if (data.creationDate && !mapData.querySelector('input[id="maps[' + data.id + '].id"]')) {
            const mapId = document.createElement('input');
            mapId.type = 'hidden';
            mapId.name = 'maps[' + data.id + '].id';
            mapId.id = 'maps[' + data.id + '].id';
            mapId.className = "modelAttribute";
            mapId.value = data.id;
            mapData.appendChild(mapId);
        }

        App.Views.Task.renderMaps(selector, data);

    }
};